<template>
  <footer>
    <div class="hp-container">
      <BulmaAccordion v-if="isMobile"
                      :dropdown="false"
                      :icon="'caret'"
                      :caretAnimation="{
              duration: '.2s',
              timerFunc: 'ease-in-out',
            }"
                      :slide="{
              duration: '.2s',
              timerFunc: 'ease',
            }"
      >
        <BulmaAccordionItem>
          <h4 slot="title" class="column-head">Reviewers</h4>
          <p slot="content">
            <template v-if="!isLoggedIn || true">
              <router-link to="/register">Register</router-link>
              <br/>
              <router-link to="/login">Sign In</router-link>
              <br/>
            </template>
            <a :href="blog_url" rel="nofollow">Blog</a>
          </p>
        </BulmaAccordionItem>
        <BulmaAccordionItem>
          <h4 slot="title" class="column-head">Businesses</h4>
          <p slot="content">
            <a :href="portal_url" rel="nofollow">Hellopeter Business</a><br/>
            <a :href="`${portal_url}/plans`" rel="nofollow">Plans&nbsp;&amp;&nbsp;Pricing</a><br/>
            <a href="https://business.hellopeter.com/login" rel="nofollow">Business sign in</a>
          </p>
        </BulmaAccordionItem>
        <BulmaAccordionItem>
          <h4 slot="title" class="column-head">Support</h4>
          <p slot="content">
            <a :href="blog_url">Resources</a><br/>
            <a :href="`${blog_url}/faqs`">FAQ's</a><br/>
            <router-link to="/contact-us">Contact us</router-link>
          </p>
        </BulmaAccordionItem>
      </BulmaAccordion>
      <template v-else>
        <div class="col-1">
          <h4 class="column-head">Reviewers</h4>
          <p class="column-content">
            <template v-if="!isLoggedIn || true">
              <router-link to="/register">Register</router-link>
              <br/>
              <router-link to="/login">Sign In</router-link>
              <br/>
            </template>
            <a :href="blog_url" rel="nofollow">Blog</a>
          </p>
        </div>
        <div class="col-2">
          <h4 class="column-head">Businesses</h4>
          <p class="column-content">
            <a :href="portal_url" rel="nofollow">Hellopeter Business</a><br/>
            <a :href="`${portal_url}/plans`" rel="nofollow">Plans&nbsp;&amp;&nbsp;Pricing</a><br/>
            <a href="https://business.hellopeter.com/login" rel="nofollow">Business sign in</a>
          </p>
        </div>
        <div class="col-3">
          <h4 class="column-head">Support</h4>
          <p class="column-content">
            <a :href="blog_url">Resources</a><br/>
            <a :href="`${blog_url}/faqs`">FAQ's</a><br/>
            <router-link to="/contact-us">Contact us</router-link>
          </p>
        </div>
      </template>
      <div class="col-4">
        <h4 class="column-head" v-if="isDesktop">Connect with us</h4>
        <p class="column-content">
          <a class="social-icon" :href="facebook" target="_blank" rel="nofollow"><i class="fab fa-facebook-f"></i></a>
          <a class="social-icon" :href="instagram" target="_blank" rel="nofollow"><i class="fab fa-instagram"></i></a>
          <a class="social-icon" :href="twitter" target="_blank" rel="nofollow"><img src="/static/img/social/twitter_black2.svg"/></a>
          <a class="social-icon" :href="linkedin" target="_blank" rel="nofollow"><i class="fab fa-linkedin-in"></i></a>
        </p>
      </div>
    </div>

    <div class="hp-container" :class="{'margin-top-52':isDesktop}">
      <div class="col-copy">
        <div class="column-content">
          &copy; Copyright 2023 hellopeter.com and its affiliates. All rights reserved.
        </div>
      </div>
      <div class="column-content" :class="{'has-text-right':isDesktop, 'has-text-centered':!isDesktop, 'full-width':!isDesktop}">
        <router-link to="/legal/legal">Terms & Conditions</router-link>
        |
        <router-link to="/legal/privacy">Privacy Policy</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
/* eslint-disable indent,no-new,no-undef */
import {misc, auth} from '@/mixins'
import {BulmaAccordion, BulmaAccordionItem} from 'vue-bulma-accordion'

export default {
  name: 'DefaultFooter',
  components: {
    BulmaAccordion,
    BulmaAccordionItem
  },
  mixins: [auth, misc],
  data () {
    return {
      blog_url: process.env.BLOG_URL,
      portal_url: process.env.PORTAL_URL,
      facebook: 'https://www.facebook.com/hellopetercom',
      twitter: 'https://twitter.com/hellopetercom',
      instagram: 'https://www.instagram.com/hellopeter_za',
      linkedin: 'https://www.linkedin.com/company/hellopeter'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

footer {
  background-color: map-get($colors, 'blue-dark');
  color: #fff;
  font-size: 16px;
  padding-top: 50px;
  padding-bottom: 74px;

  @include tablet {
    font-size: 14px;
    padding-top: 38px;
    padding-bottom: 52px;
  }

  @include mobile {
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 28px;

    .hp-container:first-child {
      max-width: 100%;
      padding: 14px 14px 0;
    }

    .hp-container:last-child {
      max-width: 279px;
    }
  }

  .hp-container {
    display: flex;
    flex-wrap: wrap;

    @include desktop {
      .col-3 {
        width: 241px;
      }
    }

    @include not-desktop {
      max-width: 605px;

      .col-4, .col-copy {
        flex-basis: 100%;
        text-align: center;
        margin-top: 30px;
      }
    }

    @include mobile {
      .col-4 {
        margin-top: 9px;
      }
    }

    .col-1 {
      width: 247px;
    }

    .col-2 {
      width: 248px;
    }

    .col-copy {
      width: 745px;

      @include tablet {
        margin-bottom: 18px;
        margin-top: 18px;
      }

      @include mobile {
        margin-top: 24px;
        margin-bottom: 23px;
      }
    }
  }

  .column-head {
    margin-bottom: 10px;
    text-transform: uppercase;
    font-weight: bold;

    @include tablet {
      margin-bottom: 12px;
    }

    @include mobile {
      margin: 3px 0 0;
    }
  }

  .column-content {
    line-height: 29px;

    @include mobile {
      line-height: 19px;
    }

    a {
      color: #fff;
    }

    .social-icon {
      color: map-get($colors, 'blue-dark');
      background-color: #fff;
      display: inline-block;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      font-size: 22px;
      line-height: 35px;
      text-align: center;
      margin: 3px 14px 0 0;

      img {
        width: 32px;
        vertical-align: text-top;
      }
    }
  }
}

footer > > > .accordion {
  flex-basis: 100%;
}

footer > > > .card {
  background-color: map-get($colors, 'blue-dark');
  box-shadow: none;
  margin-bottom: 9px;
}

footer > > > .card-header {
  box-shadow: none;
}

footer > > > .card-header-title {
  color: #fff;
  padding-top: 7px;
  padding-bottom: 7px;
}

footer > > > .card-header-icon {
  padding-top: 7px;
  padding-bottom: 7px;
}

footer > > > .card-content {
  padding: 0 0 0 12px;
}

footer > > > .card-content a {
  color: #fff;
  font-size: 14px;
  padding-bottom: 7px;
  display: inline-block;
}

footer > > > .card-header-icon svg {
  transform: rotate(90deg);
  fill: #fff;
  width: 50%;
}

footer > > > .card-active .card-header-icon svg {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/layouts/DefaultFooter.vue